import * as React from 'react';
import ReportVisual from '../powerBIComponents/ReportVisual';
import { connect } from 'react-redux'
import * as PBAction from '../../store/actions/powerBIActions'
import { Dispatch } from 'redux';
import * as pbi from 'powerbi-client';
import * as SA from '../../store/actions/applicationSettingsActions'

class PowerBIReportVisual extends React.Component<any, any> {
    constructor(props) {
        super(props);



        this.state = {
            embedConfig: {
                settings: {}
            }
        };

        this.changeEmbedConfig = this.changeEmbedConfig.bind(this);
    }

    token;
    report;
    vesselGroupName;
    imo;
    date;
    username;

    componentDidMount() {
        this.props.loadApplicationSettings();

        this.vesselGroupName = this.props.vesselGroupName;
        this.username = this.props.username;
        this.imo = this.props.imo;
        this.date = this.props.date;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.token != this.props.token) {
            this.token = this.props.token;
            this.changeEmbedConfig();
        }

        if (prevProps.userToken != this.props.userToken) {
            if (this.props.userToken != null) {
                this.props.getReport(this.props.workspaceId, this.props.reportId, this.props.webapiUrl, this.props.userToken);
            }

        }
        if (prevProps.report != this.props.report) {
            this.report = this.props.report;
            this.changeEmbedConfig();
        }
        if (prevProps.vesselGroupName != this.props.vesselGroupName) {
            this.vesselGroupName = this.props.vesselGroupName;
            this.changeEmbedConfig();
        }

        if (prevProps.username != this.props.username) {
            this.username = this.props.username;
            this.changeEmbedConfig();
        }

        if (prevProps.imo != this.props.imo && prevProps.date != this.props.date) {
            this.imo = this.props.imo;
            this.date = this.props.date;
            this.changeEmbedConfig();
        }

        if (prevProps.imo != this.props.imo && this.props.date == null) {
            this.imo = this.props.imo;
            this.changeEmbedConfig();
        }

        if (prevProps.webapiUrl != this.props.webapiUrl) {
            if (this.props.webapiUrl != null) {
                this.props.getApiToken(this.props.webapiUrl);
                //this.props.getUserToken(this.props.webapiUrl);

            }

            if (this.props.webapiUrl != null && this.props.userToken != null) {
                this.props.getReport(this.props.workspaceId, this.props.reportId, this.props.webapiUrl, this.props.userToken);
            }
        }

    }

    onEmbedded(embed) {
        /**
         * Commenting out because it's unnecessary
         * - Mason Smith 
         */
        // console.log(`Report embedded: `, embed, this);
    }


    changeEmbedConfig() {
        var slicers = null;
        var filters = [];
        if (this.vesselGroupName != null) {
            var filterName = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: "DimVesselGroup_Groups_API",
                    column: "Vessel Group Name"
                },
                operator: 'In',
                values: [this.props.vesselGroupName]

            };

            filters.push(filterName);

        }
        else if (this.imo != null && this.date != null) {

            var filterName = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: "DimClientVessel_API",
                    column: "imo"
                },
                operator: 'In',
                values: [this.props.imo]

            };

            var date = this.props.date;
            date = date.replace("T", ' ');
            date = date.replace('Z', '');

            var filterDate = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: "DimPassages_API",
                    column: "ActualDepartureTime_DT"
                },
                operator: 'In',
                values: [date]

            };


            filters.push(filterName);
            filters.push(filterDate);

            //slicers = [
            //    {
            //        selector: {
            //            $schema: "http://powerbi.com/product/schema#visualSelector",
            //            visualName: "f02efd950a1cf1f2426b"
            //        },
            //        state: {
            //            filters: [
            //                {
            //                    $schema: "http://powerbi.com/product/schema#advanced", target: { table: "DimClientVessel_API", column: "Vessel Name" }, filterType: pbi.models.FilterType.Advanced, logicalOperator: "And", conditions: [
            //                        {
            //                            operator: "Contains",
            //                            value: this.props.vesselName
            //                        }
            //                    ]
            //                }
            //            ]
            //        }
            //    },
            //    {
            //        selector: {
            //            $schema: "http://powerbi.com/product/schema#visualSelector",
            //            visualName: "f97e1a23aaa3c09491b1"
            //        },
            //        state: {
            //            filters: [
            //                {
            //                    $schema: "http://powerbi.com/product/schema#advanced", target: { table: "DimPassages_API", column: "ActualDepartureTime" }, filterType: pbi.models.FilterType.Advanced, logicalOperator: "And", conditions: [
            //                        {
            //                            operator: "Contains",
            //                            value: this.props.date
            //                        }
            //                    ]
            //                }
            //            ]
            //        }
            //    }

            //];
        }
        else if (this.imo != null) {

            var filterName = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: "DimClientVessel_API",
                    column: "imo"
                },
                operator: 'In',
                values: [this.props.imo]

            };

            filters.push(filterName);
        }

        if (this.username != null) {
            var filterusername = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: "DimVesselGroup_Users_API",
                    column: "Username"
                },
                operator: 'In',
                values: [this.username]

            };

            filters.push(filterusername);

        }

        if (this.report != null && this.token != null) {
            var embedConfig = this.state.embedConfig;
            embedConfig.id = this.props.reportId;
            embedConfig.embedUrl = this.report.embedUrl;
            embedConfig.accessToken = this.token;
            embedConfig.type = 'visual';
            embedConfig.pageName = this.props.pageName;
            embedConfig.visualName = this.props.visualId;
            embedConfig.filters = filters;

            //embedConfig.filters = [{ $schema: 'http://powerbi.com/product/schema#basic', target: { table: "DimPassages_API", column: "PassageIdentifier" }, filterType: 1, operator: "In", values: ["Great Bent - 01-05-2018 - 01-06-2018"] },
            //    { $schema: "http://powerbi.com/product/schema#basic", target: { table: "DimClientVessel_API", column: "Vessel Name" }, filterType: 1, operator: "In", values: ["BORA"] }];
            //if (slicers != null) {
            //    embedConfig.slicers = slicers;
            //}
            embedConfig.settings = {
                layoutType: pbi.models.LayoutType.Custom,
                customLayout: {
                    displayOption: pbi.models.DisplayOption.FitToWidth
                },
                filterPaneEnabled: true,
                navContentPaneEnabled: false
            };



            this.setState({ embedConfig });
        }
    }



    render() {
        var content = this.state.embedConfig != {} ? <ReportVisual
            id={this.state.embedConfig.id}
            embedUrl={this.state.embedConfig.embedUrl}
            accessToken={this.state.embedConfig.accessToken}
            type={this.state.embedConfig.type}
            pageName={this.state.embedConfig.pageName}
            visualName={this.state.embedConfig.visualName}
            filters={this.state.embedConfig.filters}
            filterPaneEnabled={this.state.embedConfig.settings.filterPaneEnabled}
            slicers={this.state.embedConfig.slicers}
            navContentPaneEnabled={this.state.embedConfig.settings.navContentPaneEnabled}
            settings={this.state.embedConfig.settings}
            onEmbedded={this.onEmbedded}
        /> : <div></div>;
        return (
            <div className='powerbi-div-style'>
                {content}
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        token: state.powerBIReducer.powerBIReportToken,
        report: state.powerBIReducer.report,
        reportId: props.reportId,
        visualId: props.visualId,
        pageName: props.pageName,
        workspaceId: props.workspaceId,
        webapiUrl: state.applicationSettingsReducer.webapiUrl,
        userToken: props.userToken


    };
}

function mapDispatchToProps(dispatch) {
    return {
        getApiToken: (webapiUrl) => dispatch(PBAction.getApiToken(webapiUrl)),
        getReport: (workspaceId, reportId, webapiUrl, token) => dispatch(PBAction.getReport(workspaceId, reportId, webapiUrl, token)),
        loadApplicationSettings: () => dispatch(SA.loadApplicationSettings()),
        getUserToken: (webapiUrl) => dispatch(PBAction.getUserToken(webapiUrl))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PowerBIReportVisual);




// WEBPACK FOOTER //
// ./src/components/i4Reports/PowerBIReportVisual.tsx